export default {
    parent: 'QuizLayout', // the layout we'll be using
    url: '/quiz/:guid?fallbackLanguage',
    abstract: true,
    template: '<ui-view></ui-view>'
};



// WEBPACK FOOTER //
// ./src/app/states/quiz/index.js